"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _ErrorBoundary = _interopRequireDefault(require("./ErrorBoundary"));

var _displayAd = _interopRequireDefault(require("./displayAd"));

var _adDisplayListeners = require("./adDisplayListeners");

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = (0, _getPrototypeOf2.default)(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = (0, _getPrototypeOf2.default)(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return (0, _possibleConstructorReturn2.default)(this, result);
  };
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
} // Suggestions on a React component using Google ads:
// https://stackoverflow.com/q/25435066/1332513
// This component needs to support server-side rendering,
// which means we need to take care to not import bidder code
// that relies on the window.


var Ad =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(Ad, _React$Component);

  var _super = _createSuper(Ad);

  function Ad() {
    (0, _classCallCheck2.default)(this, Ad);
    return _super.apply(this, arguments);
  }

  (0, _createClass2.default)(Ad, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props = this.props,
          adId = _this$props.adId,
          onError = _this$props.onError;

      try {
        // Display the ad as soon as it's available.
        (0, _displayAd.default)(adId); // On ad display, call the onAdDisplayed callback.

        (0, _adDisplayListeners.onAdRendered)(adId, this.onAdDisplayedHandler.bind(this));
      } catch (e) {
        onError(e);
      }
    } // Never update. This prevents unexpected unmounting or
    // rerendering of third-party ad content.

  }, {
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate() {
      return false;
    }
  }, {
    key: "onAdDisplayedHandler",
    value: function onAdDisplayedHandler(bidResponse) {
      var onAdDisplayed = this.props.onAdDisplayed;
      onAdDisplayed(bidResponse);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          adId = _this$props2.adId,
          onError = _this$props2.onError,
          style = _this$props2.style;
      return (
        /*#__PURE__*/
        _react.default.createElement(_ErrorBoundary.default, {
          onError: onError
        },
        /*#__PURE__*/
        _react.default.createElement("div", {
          style: style
        },
        /*#__PURE__*/
        _react.default.createElement("div", {
          id: adId,
          "data-testid": "ad-container"
        })))
      );
    }
  }]);
  return Ad;
}(_react.default.Component);

Ad.propTypes = {
  adId: _propTypes.default.string.isRequired,
  onAdDisplayed: _propTypes.default.func,
  onError: _propTypes.default.func,
  style: _propTypes.default.object // eslint-disable-line react/forbid-prop-types

};
Ad.defaultProps = {
  onAdDisplayed: function onAdDisplayed() {},
  onError: function onError() {},
  style: {}
};
var _default = Ad;
exports.default = _default;